module.exports = __webpack_public_path__ + "img/news2.13104880.png";